<template>
  <div class="assembly-work-order">
    <!--列表-->
    <el-table size="small" :data="listData" height="400px" highlight-current-row max-height="400px" stripe border element-loading-text="拼命加载中" :header-cell-style="_headerStyle" style="width: 100%;">
      <el-table-column prop="orderCode" label="工单编号" width="120">
      </el-table-column>
      <el-table-column prop="productCode" label="产品编号" width="120">
      </el-table-column>
      <el-table-column prop="productName" label="产品名称" width="120"></el-table-column>
      <el-table-column prop="specs" label="产品规格" width="80"></el-table-column>
      <el-table-column prop="editUser" label="顺序号" width="80"></el-table-column>
      <el-table-column prop="processName" label="工序名称" width="180">
      </el-table-column>
      <el-table-column  prop="taskStatus" label="状态" width="180">
      </el-table-column>
      <el-table-column prop="actualStartTime" label="实际开始日期" width="150"></el-table-column>
      <el-table-column prop="actualEndTime" label="实际结束日期 " width="150"></el-table-column>
      <el-table-column prop="planNum" label="计划数" width="150"></el-table-column>
      <el-table-column prop="goodNum" label="良品数" width="150"></el-table-column>
      <el-table-column prop="nongoodNum" label="不良品数" width="150"></el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
  </div>
</template>

<script>
import { taskGetList} from '@/api/basicData'
import Pagination from '@/components/Pagination'
export default {
  props:['editRow'],
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请请输入部门代码', trigger: 'blur' }]
      },
      form: {
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken'),
        updateCondition:'0',
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      params:{
        condition: {
        },
        currentPage: 1,
        pageSize: 10,
      },
      mode:'main',
      orderVisible:false,
      typeOptions: [{
        value: '文本',
        label: '文本'
      }, {
        value: '数字',
        label: '数字'
      },{
        value: '时间',
        label: '时间'
      }, {
        value: '照片',
        label: '照片'
      }],
      userData:JSON.parse(window.localStorage.getItem('userdata')),
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata() {
      this.loading = true
      this.params['condition'] = {
        factoryId:this.userData.factoryId,
        processCode:this.editRow.processCode
      }
      taskGetList(this.params).then(res => {
        if(res.code == 200){
          this.pageparm = res.data;
          this.listData = res.data.list;
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    // 分页插件事件
    callFather(param) {
      this.params['currentPage'] = param['currentPage'];
      this.params['pageSize'] = param['pageSize'];
      this.getdata();
    },
    // 搜索事件
    search() {
      this.getdata()
    },
  }
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/views/home/ProductionTask.vue